import React, {useEffect} from 'react';

export default function OnMapInfoPanel({data, className = '', children}) {
    return (
        <div className={'onmap-info-panel center'+(className ? ' '+className : '')}>
            {data ? data : children}
        </div>
    );
}